import yueqingwan from "./index.vue";
import yueqingwanHome from "./Home.vue";

const simpleCurrentData = () => import("./../../components/SimpleCurrentData.vue");
const dataHistory = () => import("./../../components/DataHistory.vue");
const login = () => import("./login.vue");

export default [
  {
    path: "/yueqingwanIndex",
    name: "yueqingwanIndex",
    component: yueqingwanHome
  },
  {
    path: "/yueqingwan/login",
    name: "yueqingwanLogin",
    component: login
  },
  {
    path: "/yueqingwan",
    name: "yueqingwan",
    redirect: "/yueqingwan",
    component: yueqingwan,
    children: [
      {
        path: "currentDataTable",
        name: "currentDataTable",
        component: simpleCurrentData,
      },
      {
        path: "dataHistory",
        name: "dataHistory",
        component: dataHistory
      },
    ]
  }
];
